<h2 mat-dialog-title>Auto-Forwarding</h2>

<mat-dialog-content>
  <div class="af-warning-banner">
    <mat-icon>warning_amber</mat-icon>
    <span>Future DICOM studies for this patient will be automatically sent to the selected facility.</span>
  </div>

  <div *ngIf="loadingSpokes" class="af-dialog-loading">
    <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
  </div>

  <mat-form-field *ngIf="!loadingSpokes" appearance="outline" class="af-select-field">
    <mat-label>Destination Facility</mat-label>
    <mat-select [(ngModel)]="selectedSpokeId" [disabled]="saving">
      <mat-option *ngFor="let spoke of spokes" [value]="spoke.id">
        {{ spoke.name }}
      </mat-option>
    </mat-select>
    <mat-hint *ngIf="spokes.length === 0">No facilities with AE title configured.</mat-hint>
  </mat-form-field>

  <p *ngIf="error" class="af-dialog-error">{{ error }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [disabled]="saving" (click)="onCancel()">Cancel</button>
  <button mat-flat-button
          color="primary"
          [disabled]="!selectedSpokeId || saving || loadingSpokes"
          (click)="onSave()">
    {{ saving ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
